<template>
  <div class="navbar">
    <div class="navbar_item" v-for="(item, index) in items" :key="index" :to="item.to" @click="navbarChange(item.to)">
      <img class="icon" :src="navbarIndex == index ? item.activeIcon : item.normalIcon" />
      <span :class="{ 'activeColor': navbarIndex == index }">{{ item.text }}</span>
    </div>
  </div>
</template>

<script>
import mixin from '../common/mixin/mixins'
export default {
  data() {
    return {
      items: [{
        text: '首页',
        to: '/home',
        normalIcon: require('../assets/images/idweek_new_no_square.png'),
        activeIcon: require('../assets/images/idweek_new_square.png')
      },
      {
        text: '课程',
        to: '/program',
        normalIcon: require('../assets/images/idweek_new_no_kc.png'),
        activeIcon: require('../assets/images/idweek_new_kc.png')
      },
      {
        text: '专区',
        to: '/section',
        normalIcon: require('../assets/images/zq_off.png'),
        activeIcon: require('../assets/images/zq_on.png')
      },
      {
        text: '我的',
        to: '/mine',
        normalIcon: require('../assets/images/idweek_new_no_center.png'),
        activeIcon: require('../assets/images/idweek_new_center.png')
      }]
    }
  },
  mixins: [mixin],
  computed: {
    navbarIndex() {
      return this.$store.state.navbarIndex;
    }
  },
  methods: {
    navbarChange(url) {
      if (url) {
        this.$router.push(url);
      } else {
        this.$dialog.alert({
          title: '提示',
          message: '升级中，敬请期待！',
        }).then(() => { });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  position: relative;
  display: flex;
  width: 100%;
  height: 50px;
  background-color: #FFFFFF;
  border-top: 1px solid #c0bfc4;
  z-index: 999;

  .navbar_item {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex: 1;
    font-size: 10px;
    color: rgb(12, 41, 65);

    .icon {
      display: block;
      width: 24px;
      box-sizing: border-box;
      padding: .05rem;
    }
  }
}
</style>